module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "meu-thumbex margin-10px-10px-30px",
    style: (_vm.height),
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "meu-thumbnail"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.router
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.src
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-40-3"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.label))])])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b83533a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/RenderImagem.vue
// module id = 942
// module chunks = 2